import { SvgIconType } from './svg.interface';

const Upload: SvgIconType = ({
  width = 13,
  height = 9,
  className = '',
  color = 'white'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 9"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2412 3.6875C10.3118 3.48125 10.3824 3.275 10.3824 3C10.3824 1.4875 9.11176 0.25 7.55882 0.25C6.5 0.25 5.51176 0.86875 5.08824 1.7625C4.87647 1.69375 4.59412 1.625 4.38235 1.625C3.39412 1.625 2.61765 2.38125 2.61765 3.34375C2.61765 3.48125 2.61765 3.61875 2.68824 3.6875C1.41765 3.89375 0.5 4.85625 0.5 6.09375C0.5 7.4 1.62941 8.5 2.97059 8.5H5.44118V6.4375H3.32353L6.5 3.34375L9.67647 6.4375H7.55882V8.5H10.0294C11.3706 8.5 12.5 7.4 12.5 6.09375C12.5 4.85625 11.5118 3.825 10.2412 3.6875Z"
      fill={color}
    />
  </svg>
);

export default Upload;
